"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDashboard = exports.moveDashboard = exports.verifyDashboardNameUniqueIn = exports.getEmbedUriForDashboard = exports.getAllDashboardFilters = exports.getSiteFilterForDashboard = exports.saveDashboardAs = exports.getPopularDashboardsForCurrentOrganization = exports.searchRecentlyViewedDashboard = exports.searchDashboardsAndSync = exports.searchDashboards = void 0;
const dashboardDto_1 = require("../../dtos/dashboardDto");
const recent_1 = require("./recent");
const reportElementTypes_1 = require("../../domain/reportElementTypes");
const popular_1 = require("./popular");
const folder_1 = require("./folder");
const internalAxios_1 = require("./internalAxios");
const dashboardFilter_1 = require("../../dtos/dashboardFilter");
const content_1 = require("./content");
const searchDashboards = async (searchOptions) => {
    searchOptions.fields = dashboardDto_1.DashboardDto.QUERY_FIELDS;
    let { data } = await internalAxios_1.internalAxios.post('/api/dashboard/search', {
        searchOptions,
    });
    data = data.map((dashboard) => new dashboardDto_1.DashboardDto(dashboard));
    const folderIds = await (0, folder_1.filterListofFolderIds)((0, folder_1.getUniqueListOfReportFolderIds)(data));
    const result = data.filter((reports) => folderIds?.includes(reports.folder.id));
    return result;
};
exports.searchDashboards = searchDashboards;
const searchDashboardsAndSync = async (searchOptions) => {
    return await (0, content_1.syncUser)(await (0, recent_1.syncViewCountAndDate)(reportElementTypes_1.ReportElementTypes.Dashboard, await (0, exports.searchDashboards)(searchOptions)));
};
exports.searchDashboardsAndSync = searchDashboardsAndSync;
const searchRecentlyViewedDashboard = async () => {
    const recentlyViewedReports = await (0, recent_1.getRecent)(reportElementTypes_1.ReportElementTypes.Dashboard);
    if (recentlyViewedReports.length) {
        const recentlyViewedDashboards = await (0, exports.searchDashboards)({
            id: recentlyViewedReports
                .map((recent) => recent.reportId)
                .join(','),
        });
        return await (0, content_1.syncUser)((0, recent_1.mapReportViewCountAndDate)(recentlyViewedDashboards, recentlyViewedReports));
    }
    return [];
};
exports.searchRecentlyViewedDashboard = searchRecentlyViewedDashboard;
const getPopularDashboardsForCurrentOrganization = async () => {
    const popularReports = await (0, popular_1.getPopularByType)(reportElementTypes_1.ReportElementTypes.Dashboard);
    if (popularReports.length) {
        const popularDashboards = await (0, exports.searchDashboardsAndSync)({
            id: popularReports
                .map((recent) => recent.reportId)
                .join(','),
        });
        return await (0, popular_1.syncReportPopularityForCurrentOrganization)(reportElementTypes_1.ReportElementTypes.Dashboard, popularDashboards, popularReports);
    }
    return [];
};
exports.getPopularDashboardsForCurrentOrganization = getPopularDashboardsForCurrentOrganization;
const saveDashboardAs = async (newDashboardTitle, folderId, dashboardId, changedFilters) => {
    const saveDashboardDto = {
        dashboardId: dashboardId,
        newTitle: newDashboardTitle,
        folderId: folderId,
        customFilters: Object.keys(changedFilters).map((key) => {
            if (key.trim().toLowerCase() === 'site')
                return Object.assign({ Name: key, DefaultValue: '' });
            return Object.assign({ Name: key, DefaultValue: changedFilters[key] });
        }),
    };
    const response = await internalAxios_1.internalAxios.post('/api/dashboard/save', {
        saveDashboardDto,
    });
    return response.status === 200;
};
exports.saveDashboardAs = saveDashboardAs;
const getSiteFilterForDashboard = async (dashboardId) => {
    const dashboardFilters = await (0, exports.getAllDashboardFilters)(dashboardId);
    return dashboardFilters.length === 0
        ? undefined
        : dashboardFilters.find((filter) => filter.name.toLowerCase() === 'site' &&
            filter.type === 'field_filter' &&
            filter.uiConfig?.type !== 'range_slider' &&
            filter.uiConfig?.type !== 'slider' &&
            filter.dimension === 'sites.id');
};
exports.getSiteFilterForDashboard = getSiteFilterForDashboard;
const getAllDashboardFilters = async (dashboardId) => {
    if (dashboardId === undefined) {
        return [];
    }
    const { data } = await internalAxios_1.internalAxios.get(`/api/dashboard/filters/${dashboardId}`);
    return data.map((filter) => new dashboardFilter_1.DashboardFilter(filter));
};
exports.getAllDashboardFilters = getAllDashboardFilters;
const getEmbedUriForDashboard = async (dashboardId, selectedSiteIds) => {
    const siteFilterString = selectedSiteIds && selectedSiteIds.length > 0
        ? `Site=${selectedSiteIds}`
        : '';
    const { data } = await internalAxios_1.internalAxios.get(`/api/dashboard/embed/${dashboardId}`, {
        params: {
            filterString: siteFilterString,
        },
    });
    return data.uri;
};
exports.getEmbedUriForDashboard = getEmbedUriForDashboard;
const verifyDashboardNameUniqueIn = async (dashboardName, parentFolderId) => {
    const folderDashboards = await (0, folder_1.getFolderDashboardsFor)(parseInt(parentFolderId));
    const duplicateDashboard = folderDashboards?.find((dashboard) => dashboard.title.trim().toLowerCase() ===
        dashboardName.trim().toLocaleLowerCase());
    return !duplicateDashboard;
};
exports.verifyDashboardNameUniqueIn = verifyDashboardNameUniqueIn;
const moveDashboard = async (dashboardId, folderId, dashboardTitle) => {
    return await internalAxios_1.internalAxios.post(`/api/dashboard/move`, {
        dashboardId: dashboardId,
        folderId: folderId,
        dashboardTitle: dashboardTitle,
    });
};
exports.moveDashboard = moveDashboard;
const createDashboard = async (title, folderId) => {
    const { data } = await internalAxios_1.internalAxios.post('/api/dashboard/', {
        title: title,
        folderId: folderId,
        preferredViewer: 'dashboards-next',
    });
    return new dashboardDto_1.DashboardDto(data);
};
exports.createDashboard = createDashboard;
